import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCollectionStore } from '@/features/collections/stores/useCollectionStore';
import { usePageSelection } from '@/features/pages/hooks/usePageSelection';

/**
 * This hook initializes the application by loading necessary data
 * and setting up essential effects
 */
export function useAppInitializer() {
  const { setCurrentPageId } = usePageSelection();
  const resetCurrentCollection = useCollectionStore(state => state.resetCurrentCollection);
  const location = useLocation();

  // Reset current page and collection based on route
  useEffect(() => {
    const isShared = location.pathname.includes('/shared');
    if (isShared) {
      return;
    }

    const isInCollection = location.pathname.includes('/collection/');
    const isInPage = location.pathname.includes('/page/');

    if (!isInPage) {
      void setCurrentPageId(null);
    }

    if (!isInCollection) {
      resetCurrentCollection();
    }
  }, [location.pathname, setCurrentPageId, resetCurrentCollection]);

  return null;
}
